import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import {
  obtenerInstituciones,
  sedesPorInstitucionId,
} from "../../Services/Rest";
import Swal from "sweetalert2";

function CargaOmConsecutiva() {
  const [Institucion, setInstitucion] = useState([]);
  const [Institucionid, setInstitucionid] = useState("");
  const [sede, setSede] = useState([]);
  const [sedeId, setsedeId] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState(null);

  useEffect(() => {
    const getInstitucion = async () => {
      const resInstitucion = await fetch(obtenerInstituciones);
      const rescon = await resInstitucion.json();
      setInstitucion(rescon);
    };
    getInstitucion();
  }, []);

  const handleInstitucion = (event) => {
    setInstitucionid(event.target.value);
  };

  useEffect(() => {
    if (Institucionid !== "") {
      const getSedes = async () => {
        const res = await fetch(`${sedesPorInstitucionId}${Institucionid}`);
        const data = await res.json();
        setSede(data);
      };
      getSedes();
    }
  }, [Institucionid]);

  const handleSede = (event) => {
    setsedeId(event.target.value);
  };

  const subirArchivos = (files) => {
    setArchivos(files);
  };

  const insertarArchivos = async () => {
    if (!Institucionid) {
      Swal.fire({
        title: "Selecciona una institución primero",
        icon: "warning",
      });
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < archivos.length; i++) {
      formData.append("files", archivos[i]);
    }

    const basicAuth = btoa("BasicAuth@icontec.org:yQLzqmR7eZSuAmQZUqhY");
    const headers = {
      Authorization: `Basic ${basicAuth}`,
      "Content-Type": "multipart/form-data",
    };

    setLoading(true);

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaMasivaOm?InstitucionId=${Institucionid}&SedeId=${sedeId}`,
        formData,
        { headers },
      );

      Swal.fire({ title: response.data, icon: "success" }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      Swal.fire({ title: error.message, icon: "error" }).then(() => {
        window.location.reload();
      });
    }
  };

  const Continuar = () => {
    if (!Institucionid) {
      Swal.fire({
        title: "Selecciona una institución primero",
        icon: "warning",
      });
      return;
    }
    window.location.href = `/#/OmConsecutiva/${Institucionid}`;
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  SEGUIMIENTO A LAS OPORTUNIDADES DE MEJORA INSTITUCIÓN
                </h6>
              </div>
              <div className="card-body">
                <a href="../OmFormato/FormatoOm.csv" download>
                  Descargar Formato
                </a>
                <hr />
                <div className="table-responsive">
                  {/* Selección de institución */}
                  <select
                    className="btn btn-secondary btn-user btn-block text-left"
                    onChange={handleInstitucion}
                  >
                    <option value="">Seleccione Institución</option>
                    {Institucion.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.razon_Social}
                      </option>
                    ))}
                  </select>

                  {/* Selección de sede */}
                  <select
                    className="btn btn-secondary btn-user btn-block text-left"
                    onChange={handleSede}
                  >
                    <option value="">Seleccione la sede</option>
                    {sede.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                    <option value="0">No tiene</option>
                  </select>

                  {/* Carga de archivos */}
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing="0"
                  >
                    <tbody>
                      <hr className="sidebar-divider" />
                      <input
                        type="file"
                        name="files"
                        accept=".csv"
                        multiple
                        onChange={(e) => subirArchivos(e.target.files)}
                      />
                      <hr />
                      <p>
                        {!isLoading ? (
                          <button
                            className="btn btn-primary btn-user btn-block"
                            onClick={insertarArchivos}
                          >
                            Guardar
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary btn-user btn-block"
                            disabled
                          >
                            Cargando...
                          </button>
                        )}
                      </p>
                      <hr />
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={Continuar}
                      >
                        Información de las Om
                      </button>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default CargaOmConsecutiva;
